import { KeyValueProps } from './props.js'

export function KeyValue({
  label,
  value,
  numeric = true,
  total = false,
  subdued = false,
  className = '',
}: KeyValueProps) {
  const rowClasses = [
    'flex items-baseline justify-between gap-4',
    total ? 'border-t border-outline-variant pt-2.5 mt-1' : 'py-1.5',
    subdued && 'text-on-surface-variant',
    className,
  ]
    .filter(Boolean)
    .join(' ')

  const labelClasses = [
    total ? 'text-title-sm text-on-surface' : 'text-body-sm text-on-surface-variant',
    subdued && 'text-on-surface-variant',
  ]
    .filter(Boolean)
    .join(' ')

  const valueClasses = [
    total ? 'text-title-md text-on-surface' : 'text-body-sm text-on-surface',
    numeric && 'tabular text-end',
    subdued && 'text-on-surface-variant',
  ]
    .filter(Boolean)
    .join(' ')

  return (
    <div className={rowClasses}>
      <span className={labelClasses}>{label}</span>
      <span className={valueClasses}>{value}</span>
    </div>
  )
}
